module.exports = __webpack_public_path__ + "img/osm_logo.e69a33e8.svg";